import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck,
  faTrashAlt,
  faEdit,
  faTag,
} from '@fortawesome/free-solid-svg-icons';

const customStyles = {
  rows: {
    style: {
      minHeight: '72px', // override the row height
    }
  },
  headCells: {
    style: {
      paddingLeft: '8px', // override the cell padding for head cells
      paddingRight: '8px',
    },
  },
  cells: {
    style: {
      paddingLeft: '8px', // override the cell padding for data cells
      paddingRight: '8px',
    },
  },
};

const colummnsWithFunc = (callbackDel) => {
  return [
    {
      name: 'Cantidad',
      selector: 'cantidad',
      sortable: true,
      width: '10%',
    },
    {
      name: 'Descripción',
      selector: 'descripcion_productos',
      sortable: true,
    },
    {
      name: 'Acciones',
      grow: 0,
      cell: (row) => (
        <div style={{ margin: 5, display: 'flex' }}>
          <button onClick={() => callbackDel(row)} className="btnx btnx-warn icon-table">
            <FontAwesomeIcon icon={faTrashAlt} />
          </button>
        </div>
      )
    },
  ];
}

const colummnsWithClientes = (callbackEdit, callbackDel) => {
  return [
    {
      name: 'Rut',
      selector: 'rut',
      sortable: true,
    },
    {
      name: 'Nombre completo',
      selector: 'name',
      sortable: true,
    },
    {
      name: 'Correo',
      selector: 'email',
      sortable: true,
    },
    {
      name: 'Acciones',
      grow: 0,
      cell: (row) => (
        <div style={{ margin: 5, display: 'flex' }}>
          <button onClick={() => callbackEdit(row)} className="btnx btnx-warn icon-table">
            <FontAwesomeIcon icon={faCheck} />
          </button>{' '}
        </div>
      )
    },
  ];
}

const colummnsBultos = (callbackDel, callbackEdit, callbackModal, permisoUnitGuide) => {
  return [
    {
      name: 'Alto',
      selector: 'alto',
      sortable: true,
      width: '10%',
    },
    {
      name: 'Ancho',
      selector: 'ancho',
      sortable: true,
      width: '10%',
    },
    {
      name: 'Largo',
      selector: 'largo',
      sortable: true,
      width: '10%',
    },
    {
      name: 'Peso',
      selector: 'peso',
      sortable: true,
      width: '10%',
    },
    {
      name: 'Ft3',
      selector: 'pie',
      sortable: true,
      width: '10%',
    },
    {
      name: 'Guía externa (opcional)',
      sortable: false,
      selector: 'guia_externa',
      width: '20%',
      cell: row => {
        return !row.guia_externa || row.guia_externa.trim() === '' ? 'N/A' : row.guia_externa;
      },
    },
    {
      name: 'Acciones',
      right: true,
      width: '30%',
      grow: 0,
      cell: (row) => (
        <div style={{ margin: 5, display: 'flex' }}>
          {permisoUnitGuide &&
            <button type="button" onClick={() => callbackModal(row)} className="btnx btnx-warn icon-table">
              <FontAwesomeIcon icon={faTag} />
            </button>
          }
          <button type="button" onClick={() => callbackDel(row)} className="btnx btnx-warn icon-table">
            <FontAwesomeIcon icon={faTrashAlt} />
          </button>
          <button type="button" onClick={() => callbackEdit(row)} className="btnx btnx-warn icon-table">
            <FontAwesomeIcon icon={faEdit} />
          </button>
        </div>
      )
    },
  ];
}


const tablePaquetes = {
  customStyles,
  colummnsWithClientes,
  colummnsWithFunc,
  colummnsBultos,
}

export default tablePaquetes;